module.exports = __webpack_public_path__ + "static/media/daterange.5bc6622a.png";